import { ReactComponent as PackageIcon } from "../images/svg/products/package.svg";

export const PackageSearchSelectListItem = ({ label }: { label: string }) => {
	return (
		<div className="d-flex justify-content-between align-items-center package-search-select-list-item">
			<span>{label}</span>
			<PackageIcon className="package-icon" />
		</div>
	);
};
